import { useState } from "react";
import { FaHome, FaUser, FaChevronDown, FaChevronUp } from "react-icons/fa";
import { Link } from "react-router-dom";

const Sidebar = () => {
  const [openDropdown, setOpenDropdown] = useState(null); // 'master' or 'about'

  const toggleDropdown = (menu) => {
    setOpenDropdown((prev) => (prev === menu ? null : menu));
  };

  return (
    <div className="sidebar-container">
      <div className="topbar">
        <h4>Dental</h4>
      </div>
      <div className="sidebar">
        <div className="sidebar-header">
          <img src="../../img/img.jpg" alt="logo" width={100} />
        </div>
        <ul className="sidebar-menu">
          {/* Master Dropdown */}
          <li className="sidebar-item" onClick={() => toggleDropdown("master")}>
            <span className="sidebar-icon">
              <FaHome />
            </span>
            <span className="sidebar-text">Master</span>
            <span className="dropdown-icon">
              {openDropdown === "master" ? <FaChevronUp /> : <FaChevronDown />}
            </span>
          </li>
          {openDropdown === "master" && (
            <ul>
              <Link to="/">
                <li className="dropdown-item">Banner</li>
              </Link>
              <Link to="/Emergency">
                <li className="dropdown-item">Emergancy Cases</li>
              </Link>
              <Link to="/Dentacare">
                <li className="dropdown-item">Dentacare</li>
              </Link>
              <Link to="/Meet">
                <li className="dropdown-item">Meet Dentist</li>
              </Link>
              <Link to="/Achievement">
                <li className="dropdown-item">Achievement</li>
              </Link>
              <Link to="/Price">
                <li className="dropdown-item">Price</li>
              </Link>
              <Link to="/News">
                <li className="dropdown-item">Newsletter</li>
              </Link>
              <Link to="/Testimony">
                <li className="dropdown-item">Testimony</li>
              </Link>
              <Link to="/Gallery">
                <li className="dropdown-item">Gallery</li>
              </Link>
              <Link to="/Blog">
                <li className="dropdown-item">Blog</li>
              </Link>
              <Link to="/Quote">
                <li className="dropdown-item">Quote</li>
              </Link>
            </ul>
          )}

          <Link to="/About">
            <li className="sidebar-item">
              <span className="sidebar-icon">
                <FaUser />
              </span>
              <span className="sidebar-text">About</span>
            </li>
          </Link>

          <Link to="/Service">
            <li className="sidebar-item">
              <span className="sidebar-icon">
                <FaUser />
              </span>
              <span className="sidebar-text">Service</span>
            </li>
          </Link>

          <Link to="/GalleryData">
            <li className="sidebar-item">
              <span className="sidebar-icon">
                <FaUser />
              </span>
              <span className="sidebar-text">Gallery</span>
            </li>
          </Link>

          <Link to="/Contact">
            <li className="sidebar-item">
              <span className="sidebar-icon">
                <FaUser />
              </span>
              <span className="sidebar-text">Contact</span>
            </li>
          </Link>

          <Link to="/HomeAppointmentForm">
            <li className="sidebar-item">
              <span className="sidebar-icon">
                <FaUser />
              </span>
              <span className="sidebar-text">Home Appointment Form</span>
            </li>
          </Link>

          <Link to="/QuoteForm">
            <li className="sidebar-item">
              <span className="sidebar-icon">
                <FaUser />
              </span>
              <span className="sidebar-text">Quote Form</span>
            </li>
          </Link>

          <Link to="/ContactForm">
            <li className="sidebar-item">
              <span className="sidebar-icon">
                <FaUser />
              </span>
              <span className="sidebar-text">Contact Form</span>
            </li>
          </Link>

          <Link to="/AppointmentForm">
            <li className="sidebar-item">
              <span className="sidebar-icon">
                <FaUser />
              </span>
              <span className="sidebar-text">Appointment Form</span>
            </li>
          </Link>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
